import {
	PageTitle,
	Paragraph,
	SubSectionTitle,
	WideContentContainer,
} from '../Shared/CommonStyles'; // Import shared styles

import rocacorbaImage from '../../assets/images/rocacorba.jpg';
import * as S from './Rocacorba.styles';
import RocacorbaCalendar from './RocacorbaCalendar';

// Removed local Container definition, using WideContentContainer

// Removed local Title definition, using PageTitle

// Removed local Description definition, using Paragraph

// Removed local SectionTitle definition, using SubSectionTitle

const Rocacorba = () => {
	return (
		<WideContentContainer>
			<PageTitle>Rocacorba</PageTitle>
			<S.Content>
				{/* Image & Description Column */}
				<S.ColumnContainer>
					{/* Removed SectionTitle here, main Title covers it */}
					<S.Image
						src={rocacorbaImage}
						alt="Rocacorba"
					/>
					<Paragraph>
						Rocacorba és una muntanya d&apos;uns 929m situada entre
						Canet d&apos;Adri i Banyoles. L&apos;AEIG Sant Narcís
						ens n&apos;encarreguem de la cura i de fer servei al
						santuari de Mare de Déu de Rocacorba, propietat del
						Bisbat de Girona, amb el qual tenim un conveni.
						Actualment, també en fem la gestió de les reserves, ja
						que la casa està habilitada per dormir-hi.
					</Paragraph>
					<Paragraph>
						Agrairem que durant la vostra estada al Santuari
						cuideu el lloc tal com ho fem nosaltres, i si hi ha
						qualsevol incidència contacteu amb nosaltres.
					</Paragraph>
				</S.ColumnContainer>
				{/* Calendar & Contact Column */}
				<S.CalendarContainer>
					<SubSectionTitle $align="center">
						Disponibilitat
					</SubSectionTitle>
					<RocacorbaCalendar />
					<S.ContactInfo>
						Els dies vermells ja estan reservats. Per fer una
						nova reserva, contacteu trucant al
						711 522 928
					</S.ContactInfo>
				</S.CalendarContainer>
			</S.Content>
		</WideContentContainer>
	);
};

export default Rocacorba;
